import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import CacheKeys from '../../../cache/CacheKeys';
import CacheManager from '../../../cache/CacheManager';
import MessageApprovalEmailListPageUI from './MessageApprovalEmailListPageUI'; 
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';

class MessageApprovalEmailListPageSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorList: null,
      messageList: null,
      selectedMessage: null,
      selectedMessageId: null,
      messageCreateMode: false,
      messageUpdateMode: false,
      docsUploadMode: false,
      uploadSubmitted: false,
      uploadSuccessMsg: null,
      uploadErrorList: [],
    };
  }

  render() {
    return (
      <MessageApprovalEmailListPageUI
        context={this.props.context}
        account={this.state.account}
        selectedMessage={this.state.selectedMessage}
        messageCreateMode={this.state.messageCreateMode}
        yearMonth={this.state.yearMonth}
        onPreviousClick={this.onPreviousClick}
        onNextClick={this.onNextClick}
        onCreateMessageClick={() => { this.setState({ messageCreateMode: true }) }}
        onCreateMessageCancel={() => { this.setState({ messageCreateMode: false }) }}
        messageUpdateMode={this.state.messageUpdateMode}
        onUpdateMessageClick={this.onUpdateMessageClick}
        onUpdateMessageCancel={() => { this.setState({ messageUpdateMode: false }) }}
        errorList={this.state.errorList}
        messageList={this.state.messageList}
        onRefreshClick={this.onRefreshClick}
      />
    );
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessageApprovals(context, '', '')
    this.getAccounts(context)

  }

  onUpdateMessageClick = (event) => {
    let messageApprovalId = event.currentTarget.getAttribute('message-approval-id');
    let selectedMessage = this.state.messageList.filter(msg => msg.messageApprovalId === messageApprovalId)[0];
    this.setState({ messageUpdateMode: true, selectedMessage: selectedMessage, selectedMessageId: selectedMessage.selectedMessageId });
  };

  onPreviousClick = () => {
    let context = this.props.context
    this.getMessageApprovals(context, this.state.previousYear, this.state.previousMonth)
  }

  onNextClick = () => {
    let context = this.props.context
    this.getMessageApprovals(context, this.state.nextYear, this.state.nextMonth)
  }

  getMessageApprovals(context, year, month) {
    year = year === undefined ? '' : year
    month = month === undefined ? '' : month
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/messageApprovals`,
      cacheKey: CacheKeys.MessageApprovals(this.props.match.params.accountId, year, month),
      callback: this.getMessageApprovalsCallback,
      ttlInSecs: 600
    });
    cacheManager.getObject2(context, {}, { year: year, month: month });
  }

  getMessageApprovalsCallback = (response) => {
    const filteredMessages = response.messageApprovalList ? 
      response.messageApprovalList.filter(message => message.approvalType === "customerServiceEmail") : 
      [];
      
    this.setState({
      messageList: filteredMessages,
      errorList: response.errorList,
      yearMonth: response.yearMonth,
      year: response.yearMonth.year,
      month: response.yearMonth.month,
      previousYear: response.yearMonth.prevYear,
      previousMonth: response.yearMonth.prevMonth,
      nextYear: response.yearMonth.nextYear,
      nextMonth: response.yearMonth.nextMonth
    });
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.MessageApprovals(this.props.match.params.accountId, this.state.year, this.state.month));
    this.setState({ messageList: null, errorList: null });
    this.getMessageApprovals(this.props.context, this.state.year, this.state.month);
  }
}

export default withRouter(MessageApprovalEmailListPageSF);
